import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {ResidentForSelect, Classified} from '../../../types/data.types';
import {ClassifiedsService} from '../../../services/classifieds.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'classifieds-modal',
    templateUrl: './classifieds-modal.component.html',
    styleUrls: ['./classifieds-modal.component.scss']
})
export class ClassifiedsModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    suites: Array<any> = [];
    residents: Array<ResidentForSelect> = [];
    data = new Classified();
    disabledSubmit = false;
    playlistSelectIsDisabled = false;
    startDate = new Date();
    expiryDate = new Date();
    model = {title: '', content: '', phone: '', name: ''};
    focusedItem = '';

    // static parseTime(dateString: string): string {
    //     return (new DatePipe('en-US')).transform(dateString, 'hh:mm a');
    // }

    constructor(
        public api: ApiClientService,
        public classifiedsService: ClassifiedsService,
        public urlService: UrlService
    ) {
    }

    ngOnInit() {
        this.initData();
        setTimeout(() => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        if (this.classifiedsService.classifiedInClassifiedModal) {
            this.data = this.classifiedsService.classifiedInClassifiedModal;
            this.getSuites(this.data.buildingId, this.data.suiteId);
        } else {
            this.data.status = 'available';
            const b = this.urlService.queryParams['building'];
            if (b) {
                this.data.buildingId = b;
                this.getSuites(this.data.buildingId);
            }

            if (this.classifiedsService.buildings.length === 1) {
                this.data.buildingId = this.classifiedsService.buildings[0].id;
                this.getSuites(this.data.buildingId);
            }
        }
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.classifiedsService.isClassifiedsModalShow = false;
                    this.classifiedsService.classifiedInClassifiedModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.classifiedsService.isClassifiedsModalShow = false;
            this.classifiedsService.classifiedInClassifiedModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.keyTag) toastr.warning('Key Tag should not be blank.');
            if (!form.value.buildingId) toastr.warning('Building should not be blank.');
            if (!form.value.suiteId) toastr.warning('Unit should not be blank.');
            return;
        }
        const building = this.classifiedsService.buildings.find((item) => item.id == form.value.buildingId);
        const suite = this.suites.find((item) => item.id == form.value.suiteId);
        if (!suite) {
            toastr.warning('Suite not found.');
            return;
        }

        const data: any = {
            building: {
                bdId: form.value.buildingId,
                name: building ? building.name : null,
            },
            suite: {
                bdId: suite.id ? form.value.suiteId : 0,
                suiteNumber: suite.id ? suite.name : form.value.otherSuite,
            },
            keyTag: form.value.keyTag,
            purpose: form.value.purpose,
            status: form.value.status,
            notes: form.value.notes
        };

        this.disabledSubmit = true;

        if (this.data.id) {
            this.api.patch('domainKeyLog', `/v1/key_log/${this.data.id}.json`, data).subscribe(
                () => this.updateView('Key Log successfully updated'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Edit Key Log failed');
                }
            );
        } else {
            this.api.post('domainKeyLog', '/v1/key_log.json', data).subscribe(
                () => this.updateView('Key Log successfully created'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Create Key Log failed');
                }
            );
        }
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.classifiedsService.getData();
        this.form.reset();
        this.hideModal();
    }

    changePlaylist(playlistId: string) {
        this.form.controls['suiteId'].reset();
        // this.form.controls['residentId'].reset();
        this.getSuites(+playlistId);
    }

    changeUnit(suiteId: string) {
        // this.form.controls['residentId'].reset();
        // this.getResidents(+suiteId);
        if (suiteId + '' === '0') {
            // this.form.controls['residentId'].setValue(0);
            // this.data.residentId = 0;
            this.data.suiteNumber = '';
            // this.data.residentFullName = '';
            // this.residents.push(new ResidentForSelect(0, 'Other'));
        }
    }

    // changeResident(residentId: string) {
    //     if (residentId === '0') this.data.residentFullName = '';
    // }

    getSuites(buildingId: number, suiteId?: number): void {
        if (!buildingId) return;
        this.suites = [];
        this.residents = [];
        this.playlistSelectIsDisabled = true;
        const url = `/v1/suites.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.api.get('domainBD', url).subscribe(
            res => {
                const suites = JSON.parse(res._body).entities || [];
                suites.forEach(
                    suite => this.suites.push({id: suite.id, name: suite.suiteNumber})
                );
                this.suites.push({id: 0, name: 'Other'});
                // if (suiteId) this.getResidents(suiteId);
                // else this.residents.push(new ResidentForSelect(0, 'Other'));
            },
            error => this.api.errorHandler(error, 'Failed get suites'),
            () => this.playlistSelectIsDisabled = false
        );
    }

    // getResidents(suiteId: number): void {
    //     this.residents = [];
    //     if (!suiteId) return;
    //     const url = `/v1/residents.json?per-page=1000&waiver_parcel=1&suite_id=${suiteId}`;
    //     this.api.get('domainBD', url).subscribe(
    //         res => {
    //             const residents = JSON.parse(res._body).entities;
    //             residents.forEach(item => {
    //                 if (item.parcelWaiverSigned) {
    //                     this.residents.push(
    //                         new ResidentForSelect(item.id, item.fullName, [], item.email)
    //                     );
    //                 }
    //             });
    //             this.residents.push(new ResidentForSelect(0, 'Other'));
    //         },
    //         error => this.api.errorHandler(error, 'Failed get Residents')
    //     );
    // }

    suiteToSearchSelect(arr: Array<any>) {
        return arr.map(
            suite => (
                {value: suite.id, optionText: suite.name}
            )
        );
    }

    changeStyle(property: string, direction: string): void {
        if (property == 'font_size') {
            if (direction == 'font_big') {
                if (document.getElementsByName(this.focusedItem)[0].style.fontSize) {
                    let currentFontSize =
                        document.getElementsByName(this.focusedItem)[0].style.fontSize.substring(0, document.getElementsByName(this.focusedItem)[0].style.fontSize.indexOf('px'));
                    if (parseInt(currentFontSize) < 35)
                        document.getElementsByName(this.focusedItem)[0].style.fontSize = parseInt(currentFontSize) + 1 + 'px';
                } else
                    document.getElementsByName(this.focusedItem)[0].style.fontSize = '15px';
            } else if (direction == 'font_sm') {
                if (document.getElementsByName(this.focusedItem)[0].style.fontSize) {
                    let currentFontSize =
                        document.getElementsByName(this.focusedItem)[0].style.fontSize.substring(0, document.getElementsByName(this.focusedItem)[0].style.fontSize.indexOf('px'));
                    if (parseInt(currentFontSize) > 8)
                        document.getElementsByName(this.focusedItem)[0].style.fontSize = parseInt(currentFontSize) - 1 + 'px';
                } else
                    document.getElementsByName(this.focusedItem)[0].style.fontSize = '13px';
            }
        } else if (property == 'text') {
            if (direction == 'text_left') {
                document.getElementsByName(this.focusedItem)[0].style.textAlign = 'left';
            } else if (direction == 'text_center') {
                document.getElementsByName(this.focusedItem)[0].style.textAlign = 'center';
            } else if (direction == 'text_right') {
                document.getElementsByName(this.focusedItem)[0].style.textAlign = 'right';
            } else if (direction == 'text_just') {
                document.getElementsByName(this.focusedItem)[0].style.textAlign = 'justify';
            }
        }

    }
}



// WEBPACK FOOTER //
// /app/src/app/views/classifieds/classifieds-modal/classifieds-modal.component.ts